import {Component, Input} from '@angular/core';
import { CommonModule } from '@angular/common';
import {PII_LEVEL} from '@app/views/admin/application-settings/components/basic/pii-shield-level-info/pii-shield.model';
import {MatLegacyCardModule} from '@angular/material/legacy-card';

@Component({
    selector: 'ngc-pii-shield-level-small-badge',
    standalone: true,
    imports: [CommonModule, MatLegacyCardModule],
    templateUrl: './pii-shield-level-small-badge.component.html',
    styleUrls: ['./pii-shield-level-small-badge.component.scss']
})
export class PIIShieldLevelSmallBadgeComponent {

    @Input() piiShieldLevel: PII_LEVEL;
    @Input() isIcon = true;
    @Input() extraSmall = true;
    @Input() small = false;
    @Input() medium = false;
    @Input() large = false;

    readonly PII_SHIELD_LEVEL_BADGES_SOURCES_MAP = {
        icon1: 'assets/images/logos/other/pii-shield/1_Sm_PII_Shield_Level.svg',
        icon2: 'assets/images/logos/other/pii-shield/2_Sm_PII_Shield_Level.svg',
        icon3: 'assets/images/logos/other/pii-shield/3_Sm_PII_Shield_Level.svg',
        image1: 'assets/images/logos/other/pii-shield/1_Lg_PII_Shield_Level.svg',
        image2: 'assets/images/logos/other/pii-shield/2_Lg_PII_Shield_Level.svg',
        image3: 'assets/images/logos/other/pii-shield/3_Lg_PII_Shield_Level.svg'
    };

    protected readonly PII_LEVEL = PII_LEVEL;
}
